import { signOut } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { createAuthLogger } from "../utils/logger";

export const Logout = () => {
    const [error, setError] = useState('');

    useEffect(() => {
        const performLogout = async () => {
            try {
                // Signing out
                await signOut();
                // Sign out successful
                
                // Redirect to home page after successful logout
                window.location.href = '/#/';
            } catch (error) {
                const logger = createAuthLogger('signOut', undefined);
                logger.error('Sign out error', { error: error instanceof Error ? error.message : String(error) });
                setError(error instanceof Error ? error.message : 'Sign out failed');
            }
        };

        performLogout();
    }, []);

    if (error) {
        return (
            <div>
                <h2>Logout Error</h2>
                <p style={{ color: 'red' }}>{error}</p>
                <button onClick={() => window.location.href = '/#/'}>
                    Return to Home
                </button>
            </div>
        );
    }

    return (
        <div>
            <h2>Logging out...</h2>
            <p>Please wait while we sign you out.</p>
        </div>
    );
};
